// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width: 500px){.my__radio[data-v-1ae9d288] .el-radio{margin-left:0;margin-right:1em}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
